// Firebase configuration
import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyDVRsup0CsD5T5Ya6V52x37A4uHWe2yR-Y",
  authDomain: "doornoc.firebaseapp.com",
  databaseURL: "https://doornoc-default-rtdb.firebaseio.com",
  projectId: "doornoc",
  storageBucket: "doornoc.appspot.com",
  messagingSenderId: "280072100489",
  appId: "1:280072100489:web:35dbc1de732437c6d48458",
  measurementId: "G-L1TFWLHXCE"
};

// Debug logging for deployment troubleshooting
console.log('Firebase Environment:', {
  nodeEnv: process.env.NODE_ENV,
  hostname: window.location.hostname,
  protocol: window.location.protocol,
  userAgent: navigator.userAgent.substring(0, 100)
});

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Auth with better error handling
export const auth = getAuth(app);

// Initialize Google Auth Provider
export const googleProvider = new GoogleAuthProvider();

// Configure auth for production
if (process.env.NODE_ENV === 'production') {
  console.log('Firebase Auth configured for production');
}

// Use production Firebase in all environments (shared auth with DoorKnock)
console.log('Using production Firebase Auth (shared with DoorKnock)');

export default app;